import React, { useState, useEffect } from "react";
import "./BannerSlider.css";
import apiClient from "../api/apiClient";

const DEFAULT_MESSAGES = [
  { id: 1, text: "Join Our Premium Program - Get 30% Off!", bg_color: "#000000", text_color: "#fff" },
  { id: 2, text: "New Batch Starting - Limited Seats Available!", bg_color: "#000000", text_color: "#fff" },
  { id: 3, text: "Summer Fitness Challenge - Win Amazing Prizes!", bg_color: "#000000", text_color: "#fff" },
];

const BannerSlider = ({ messages = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoPlay, setIsAutoPlay] = useState(true);
  const [apiMessages, setApiMessages] = useState([]);

  useEffect(() => {
    apiClient.get("/homepage/banner-announcements")
      .then(({ data }) => { if (data && data.length > 0) setApiMessages(data); })
      .catch(() => {});
  }, []);

  const bannerMessages = apiMessages.length > 0
    ? apiMessages
    : messages.length > 0 ? messages : DEFAULT_MESSAGES;

  useEffect(() => {
    if (!isAutoPlay || bannerMessages.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % bannerMessages.length);
    }, 5000); // Change message every 5 seconds

    return () => clearInterval(interval);
  }, [isAutoPlay, bannerMessages.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoPlay(false);
    // Resume autoplay after 8 seconds
    setTimeout(() => setIsAutoPlay(true), 8000);
  };

  const goToPrev = () => {
    setCurrentIndex(
      (prev) => (prev - 1 + bannerMessages.length) % bannerMessages.length
    );
    setIsAutoPlay(false);
    setTimeout(() => setIsAutoPlay(true), 8000);
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev + 1) % bannerMessages.length);
    setIsAutoPlay(false);
    setTimeout(() => setIsAutoPlay(true), 8000);
  };

  if (bannerMessages.length === 0) return null;

  const currentMessage = bannerMessages[currentIndex];

  return (
    <div
      className="banner-slider"
      style={{
        backgroundColor: currentMessage.bg_color || currentMessage.bgColor,
        color: currentMessage.text_color || currentMessage.textColor,
      }}
    >
      <div className="banner-content">
        <div className="banner-text-wrapper">
          <p className="banner-text">{currentMessage.text}</p>
        </div>

        {/* Navigation Controls */}
        {bannerMessages.length > 1 && (
          <div className="banner-controls">
            <button
              className="banner-nav-btn banner-prev"
              onClick={goToPrev}
              aria-label="Previous message"
            >
              <i className="fa fa-chevron-left"></i>
            </button>

            <div className="banner-dots">
              {bannerMessages.map((_, index) => (
                <button
                  key={index}
                  className={`banner-dot ${index === currentIndex ? "active" : ""}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Go to slide ${index + 1}`}
                ></button>
              ))}
            </div>

            <button
              className="banner-nav-btn banner-next"
              onClick={goToNext}
              aria-label="Next message"
            >
              <i className="fa fa-chevron-right"></i>
            </button>
          </div>
        )}

        {/* Close button */}
        <button
          className="banner-close"
          onClick={() => setCurrentIndex(-1)}
          aria-label="Close banner"
        >
          <i className="fa fa-times"></i>
        </button>
      </div>
    </div>
  );
};

export default BannerSlider;
